import DataUtility from "@/services/DataUtility";
import { Unit } from "@/types";
// import UserLogin from "@/utility/User";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import MasterReferensi from "@/services/MasterReferensi";

export interface UnitState {
  unitPagi: Unit[];
  unit: Unit[];
  unitRanap: Unit[];
}

@Module({ store, dynamic: true, name: "storeUnit" })
class UnitStore extends VuexModule implements UnitState {
  unitPagi: Unit[] = [];
  unit: Unit[] = [];
  unitRanap: Unit[] = [];

  @Mutation SET_UNIT_PAGI(unitPagi: Unit[]) {
    this.unitPagi = unitPagi;
  }

  @Mutation SET_UNIT(unit: Unit[]) {
    this.unit = unit;
  }

  @Mutation SET_UNIT_RANAP(data: Unit[]) {
    this.unitRanap = data;
  }

  @Action act_on_all() {
    const dt = DataUtility.getListUnitRalan();
    dt.then(dt => {
      const unit = dt;
      this.SET_UNIT(unit);
    });
  }

  @Action act_on_all_pagi() {
    const dt = DataUtility.getListUnitRalanPagi();
    dt.then(dt => {
      const unitPagi = dt;
      this.SET_UNIT_PAGI(unitPagi);
    });
  }
  @Action act_on_all_by_ip(ip) {
    // const dt = DataUtility.getListUnitRalanPagi();
    const dt = DataUtility.getListUnitRalanByIp(ip);
    dt.then(dt => {
      const unit = dt;
      this.SET_UNIT(unit);
    });
  }

  @Action
  async getUnitRanap() {
    const resp = await MasterReferensi.getUnitRanap();

    this.SET_UNIT_RANAP(resp.data);
  }
}

export const storeUnit = getModule(UnitStore);
